var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({class:[
    'ms-col',
    'ms-xs-'+_vm.msXs,
    'ms-sm-'+_vm.msSm,
    'ms-lg-'+_vm.msLg,
  ],style:({
    'order':_vm.msOrder,
    'justify-content':_vm.msJustify,
    'display':_vm.msType,
    'align-items':_vm.msAlign,
    'margin-left': _vm.getOffset,
    'width': _vm.getWidth,
    })},'div',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }